module.exports = "<i class=\"spark-icon--fill spark-icon-ban system-status-error\" title={{value}}></i>";